export default function swDev() {
	if (process.env.REACT_APP_DISABLE_CACHE === 'true') {
		if ('serviceWorker' in navigator) {
			navigator.serviceWorker.getRegistrations().then(function(registrations) {
				for (let registration of registrations) {
					registration.unregister();
				}
			});
		}
		return;
	}

	if('serviceWorker' in navigator) {
		let swUrl = `${process.env.PUBLIC_URL}/sw.js`;
		navigator.serviceWorker.register(swUrl);
	}
}